import { Atom, atom } from 'jotai'
import moment from 'moment'

interface OKRCycle {
  cycleId: number
  name: string
  startDate: string
  endDate: string
}

export const okrCyclesAtom: Atom<OKRCycle[]> = atom([])

export const currentOKRCycleAtom = atom((get) =>
  get(okrCyclesAtom)
    .filter((c) => c.name.includes('Q'))
    .find((c) => moment().isBetween(moment(c.startDate), moment(c.endDate), 'day', '[]'))
)
